import { Flex, Table } from 'antd';
import { APPROVED_COLUMNS } from './appColumns';


export default function ApprovedLoanTable({ dataSource, isLoading, pagination,ACC_APPROVED_COLUMNS=APPROVED_COLUMNS }) {

    return (
        <Flex gap="middle" vertical>
            <Table
                scroll={{ x: 'max-content' }}
                pagination={pagination}
                loading={isLoading}
                columns={ACC_APPROVED_COLUMNS}
                dataSource={dataSource}
            />
        </Flex>
    );
};